import { ReactNode } from 'react'

import GoBackButton from '../../button/ui/GoBackButton'
import { AppModal } from '../../modal'

type Props = {
  onClose: () => void
  placeholder: string
  isOpen: boolean
  children: ReactNode
}

export const CalendarModal = ({
  onClose,
  placeholder,
  isOpen,
  children
}: Props) => (
  <AppModal
    className="mx-0 h-full w-full rounded-0 bg-white"
    headerWrapperClassName="pb-14 pt-22 px-22"
    contentClassName="px-16 mt-20 pb-24 justify-center overflow-y-visible"
    header={
      <div className="flex items-center gap-24">
        <GoBackButton onClick={onClose} />
        <span className="text-20">{placeholder}</span>
      </div>
    }
    opened={isOpen}
    onClose={onClose}
  >
    {children}
  </AppModal>
)
